var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegeneration = function SvgRegeneration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    style: {
      color: "#d6e5f2"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.707 3.707a1 1 0 0 0-1.414-1.414l-2 2a1 1 0 0 0 0 1.414l2 2a1 1 0 1 0 1.415-1.414l-.064-.064a6 6 0 0 1 1.903 10.61 1 1 0 0 0 1.183 1.614 8 8 0 0 0-3.423-14.346l.4-.4Zm-3.414 16.586.4-.4A8 8 0 0 1 7.272 5.547 1 1 0 1 1 8.453 7.16a6 6 0 0 0 1.904 10.61l-.064-.063a1 1 0 1 1 1.415-1.414l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.415-1.414Z",
    clipRule: "evenodd"
  })));
};
export default SvgRegeneration;